{
	"update-info": {
		"forced": {
			"message": "Den nåværende versjonen støttes ikke lenger. \nGå til appbutikken din og oppdater til den nyeste versjonen.",
			"title": "Vi ber deg oppdatere appen"
		},
		"optional": {
			"title": "Ny versjon tilgjengelig!",
			"message": "Oppdater til den nyeste versjonen når du er klar til å nyte de nyeste funksjonene."
		},
		"whats-new": "Hva er nytt",
		"update-now": "Oppdater nå",
		"maybe-later": "Kanskje senere",
		"version": "Versjon"
	}
}
